import 'reflect-metadata';
import { Container } from 'inversify';

const getContainer = () =>
  new Container({
    autoBindInjectable: true,
    defaultScope: 'Singleton',
  });

const container = getContainer();

export default container;
